<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>课程标签列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 搜索 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openTag()">添加</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="taskTagData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <el-table-column align="center" sortable prop="name" label="标签名称" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="description" label="描述" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="getTagxq(scope.row)">查看标签详情</el-button>
                    <el-button size="mini" type="primary" @click="openTag(scope.row)">修改</el-button>
                    <el-button size="mini" type="danger" @click="deleTag(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="60%">
            <el-form label-width="120px">
                <el-form-item label="标签名">
                    <el-input size="small" v-model="name" auto-complete="off" placeholder="请输入商品名"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input size="small" v-model="description" auto-complete="off" placeholder="请输入描述"></el-input>
                </el-form-item>
                <el-form-item label="score">
                    <el-input size="small" v-model="score" auto-complete="off" placeholder="请输入score"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addTag()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upTag()" v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 查看详情 -->
        <el-dialog title="课程标签详情页：" :visible.sync="editFormDetails">
            <el-form label-width="120px">
                <el-form-item label="标签名称：">
                    <span v-html="this.Details.name"></span>
                </el-form-item>
                <el-form-item label="描述：">
                    <span v-html="this.Details.description"></span>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    {{ transformDate(this.Details.createTime) }}
                </el-form-item>
            </el-form>
        </el-dialog>


        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
import {
    getTaskTagList,
    getTaskTagInfo,
    addTaskTag,
    deleteTaskTag,
    upTaskTag
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            taskTagData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            editFormDetails: false,
            Details: [],
            tit: '添加',
            editFormVisiible: false,
            name: '',
            description: '',
            score: '',
            createTime: ''
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    created() {
        this.getData(1)
    },
    methods: {
        // 添加
        addTag() {
            this.loading = true,
                addTaskTag({
                    id: '',
                    name: this.name,
                    description: this.description,
                    score: this.score,
                    createTime: this.createTime,
                }).then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.editFormVisiible = false
                        this.$message.success(res.msg)
                        this.getData(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg);
                    }
                })
        },
        // 修改
        upTag() {
            this.loading = true,
                upTaskTag({
                    id: this.id,
                    name: this.name,
                    description: this.description,
                    score: this.score,
                    createTime: this.createTime,
                }).then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.editFormVisiible = false
                        this.$message.success(res.msg)
                        this.getData(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg);
                    }
                })
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 打开编辑器
        openTag(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改";
                this.id = row.id;
                this.name = row.name;
                this.description = row.description;
                this.score = row.score;
                this.createTime = row.createTime;
            } else {
                this.tit = "添加";
                this.name = '';
                this.description = '';
                this.score = '';
                this.createTime = '';
            }
        },
        // 删除
        deleTag(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deleteTaskTag(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getData(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 详情
        getTagxq(row) {
            this.loading = true;
            this.editFormDetails = true;
            let data = {
                id: row.id
            }
            getTaskTagInfo(data).then((res) => {
                this.loading = false;
                console.log(res)
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    this.Details = res.data.data;
                    return;
                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.getData(parm.currentPage)
        },
        // 获取数据
        getData(page) {
            this.loading = true;
            let data = {
                page: (page - 1) * 20,
            }
            getTaskTagList(data).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.taskTagData = res.data.list
                    this.pageparm.currentPage = page
                    this.pageparm.total = res.data.count
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/task/TaskTag.vue